import { render } from "./WorkCommunity.vue?vue&type=template&id=1cb2a228&scoped=true"
import script from "./WorkCommunity.vue?vue&type=script&lang=js"
export * from "./WorkCommunity.vue?vue&type=script&lang=js"

import "./WorkCommunity.vue?vue&type=style&index=0&id=1cb2a228&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb2a228"]])

export default __exports__